// Tabs slider from ava-matrix (boxes-tabs-slider.js), limited to the tabs-v2 template.
document.addEventListener('DOMContentLoaded', () => {
    const tabsSectionEls = Array.from(
        document.querySelectorAll('section.template-boxes--tabs.v2')
    );

    if (tabsSectionEls.length === 0) return;

    const scrollTabIntoView = (tabLinkEl) => {
        const itemEl = tabLinkEl.closest('li');
        const scrollContainerEl =
            tabLinkEl.closest('.uk-slider-items') || tabLinkEl.closest('[uk-slider]');

        if (!itemEl || !scrollContainerEl) return;

        const containerRect = scrollContainerEl.getBoundingClientRect();
        const itemRect = itemEl.getBoundingClientRect();
        const edgeOffset = 12;
        const rightRevealOffset = Math.min(
            Math.max(containerRect.width * 0.3, 60),
            140
        );

        let scrollDelta = 0;

        if (itemRect.left < containerRect.left + edgeOffset) {
            scrollDelta = itemRect.left - containerRect.left - edgeOffset;
        } else if (itemRect.right > containerRect.right - rightRevealOffset) {
            scrollDelta =
                itemRect.right - containerRect.right + rightRevealOffset;
        }

        if (scrollDelta === 0) return;

        scrollContainerEl.scrollBy({
            left: scrollDelta,
            behavior: 'smooth',
        });
    };

    const enableDragScroll = (sliderItemsEl) => {
        let isPointerDown = false;
        let startX = 0;
        let startScrollLeft = 0;
        let didDrag = false;

        sliderItemsEl.addEventListener('pointerdown', (event) => {
            if (window.matchMedia('(min-width: 992px)').matches) return;

            isPointerDown = true;
            didDrag = false;
            startX = event.clientX;
            startScrollLeft = sliderItemsEl.scrollLeft;
            sliderItemsEl.classList.add('is-dragging');
        });

        sliderItemsEl.addEventListener('pointermove', (event) => {
            if (!isPointerDown) return;

            const deltaX = event.clientX - startX;
            if (Math.abs(deltaX) > 5) {
                didDrag = true;
                event.preventDefault();
            }

            sliderItemsEl.scrollLeft = startScrollLeft - deltaX;
        });

        const stopDragging = () => {
            isPointerDown = false;
            sliderItemsEl.classList.remove('is-dragging');
        };

        sliderItemsEl.addEventListener('pointerup', stopDragging);
        sliderItemsEl.addEventListener('pointercancel', stopDragging);
        sliderItemsEl.addEventListener('pointerleave', stopDragging);

        sliderItemsEl.addEventListener(
            'click',
            (event) => {
                if (!didDrag) return;

                event.preventDefault();
                event.stopPropagation();
                didDrag = false;
            },
            true
        );
    };

    tabsSectionEls.forEach((sectionEl) => {
        sectionEl
            .querySelectorAll('[uk-slider] .uk-slider-items')
            .forEach(enableDragScroll);

        sectionEl.addEventListener('click', (event) => {
            const tabLinkEl = event.target.closest('.nav-tabs .nav-link');

            if (!tabLinkEl || !sectionEl.contains(tabLinkEl)) return;
            if (window.matchMedia('(min-width: 992px)').matches) return;

            requestAnimationFrame(() => {
                scrollTabIntoView(tabLinkEl);
            });
        });
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/tabs-v2-slider.js